import DuplicateStatus from "@mapmycustomers/shared/enum/DuplicateStatus";

export const DUPLICATE_ACTIVE_STATUSES = [
  DuplicateStatus.ERRORED,
  DuplicateStatus.ONGOING,
  DuplicateStatus.OPEN,
];
